import React from 'react'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { toCurrency } from '../_helpers/pdfHelpers'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'

const HourTable = ({ totalOfHours, pricePerHour, total }) => {
  return (
    <>
      <Grid justify="end" style={{ padding: '0.5rem 1rem' }}>
        <Table width="35%" style={{ border: '2px solid #333' }} color="#000">
          <TableRow style={{ backgroundColor: '#a6a6a6' }} color="#000">
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Preço p/ hora
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Total de hora
              </Text>
            </TableCol>
            <TableCol color="#000" width="23%">
              <Text bold size="small" align="center">
                Total
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#000">
            <TableCol color="#000">
              <Text size="small" align="center" color="#000">
                {toCurrency(pricePerHour)}
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text size="small" align="center" color="#000">
                {totalOfHours}
              </Text>
            </TableCol>
            <TableCol color="#000" style={{ backgroundColor: '#ffc000' }}>
              <Text size="small" align="center" color="#000">
                {toCurrency(total)}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </Grid>
    </>
  )
}

export default HourTable
